// Display vocabulary for business reviews.
//
// The score and health bands are computed on the SERVER (Business Review Service,
// utils/scoring.js) and every response carries `health` as a string. What is here is
// presentation only — labels, letters and class names — plus one optimistic score used
// while an edit is in flight, before the server's answer lands. If these two ever
// disagree, the server wins: it is what gets stored and what the client deliverable
// renders from.

export const RATINGS = ["red", "yellow", "green", "unrated", "na"];

// Every swatch carries a letter as well as a colour. Assessments get printed in
// greyscale more often than anyone expects, and roughly one man in twelve cannot
// separate the red from the green.
export const RATING_LETTER = { red: "R", yellow: "Y", green: "G", unrated: ".", na: "NA" };
export const RATING_LABEL = {
  red: "Immediate attention",
  yellow: "Needs improvement",
  green: "In good shape",
  unrated: "Not rated",
  na: "Out of scope",
};

export const HEALTH_LABEL = { strong: "Strong", watch: "Watch", atrisk: "At risk", unscored: "Unscored" };

export const STATE_LABEL = { draft: "Draft", ready: "Ready", presented: "Presented" };
export const TYPE_LABEL = { baseline: "Baseline", proposed: "Proposed", business_review: "Business review" };

export const SOURCE_LABEL = {
  consultant: "Consultant",
  scan: "Scan",
  not_rated: "Not rated",
  out_of_scope: "Out of scope",
};

// Mirrors the server's scoreFor. Used only to keep the ring moving while a rating saves;
// the response replaces it.
const RATING_VALUE = { green: 1, yellow: 0.5, red: 0, unrated: 0 };
export function optimisticScore(items) {
  let earned = 0;
  let possible = 0;
  let rated = 0;
  for (const item of items || []) {
    if (item.rating === "na") continue;
    const weight = Number(item.weight) || 0;
    if (weight <= 0) continue;
    if (item.rating !== "unrated") rated += 1;
    possible += weight;
    earned += weight * (RATING_VALUE[item.rating] ?? 0);
  }
  if (possible === 0 || rated === 0) return null;
  return Math.round((earned / possible) * 100);
}

export const healthFor = (score) => {
  if (score === null || score === undefined) return "unscored";
  if (score >= 70) return "strong";
  if (score >= 50) return "watch";
  return "atrisk";
};

export const ratingCounts = (items) => {
  const counts = { red: 0, yellow: 0, green: 0, unrated: 0, na: 0 };
  for (const item of items || []) if (counts[item.rating] !== undefined) counts[item.rating] += 1;
  return counts;
};

export const fmtScore = (score) => (score === null || score === undefined ? "." : String(score));
